import React, { createContext, useMemo } from 'react';
import { useLocalStorage } from '../services/useLocalStorage';

export const RouteContext = createContext();

export const RouteProvider = ({ children }) => {
	const [convo, setConvo] = useLocalStorage('convo_id', 0);

	// call this function when you want to stablish the convocatoria selected
	const setConvocatoria = (id) => {
		setConvo(id);
	};

	// call this function to remove convocatoria selected
	const removeConvocatoria = () => {
		setConvo(0);
	};

	const value = useMemo(
		() => ({
			convo,
			setConvocatoria,
			removeConvocatoria,
		}),
		[convo]
	);

	return <RouteContext.Provider value={value}>{children}</RouteContext.Provider>;
};
